/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ value: NonNullable<unknown> }} Workout_Live_Record_WasInputs */

const en_us2_workout_live_record_was = /** @type {(inputs: Workout_Live_Record_WasInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`was ${i?.value}`)
};

const pt_br2_workout_live_record_was = /** @type {(inputs: Workout_Live_Record_WasInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`antes ${i?.value}`)
};

const es_419_workout_live_record_was = /** @type {(inputs: Workout_Live_Record_WasInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`antes ${i?.value}`)
};

const pt_pt2_workout_live_record_was = /** @type {(inputs: Workout_Live_Record_WasInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`antes ${i?.value}`)
};

const fr_fr2_workout_live_record_was = /** @type {(inputs: Workout_Live_Record_WasInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`avant : ${i?.value}`)
};

const de_de2_workout_live_record_was = /** @type {(inputs: Workout_Live_Record_WasInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`vorher ${i?.value}`)
};

const it_it2_workout_live_record_was = /** @type {(inputs: Workout_Live_Record_WasInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`prima ${i?.value}`)
};

/**
* | output |
* | --- |
* | "was {value}" |
*
* @param {Workout_Live_Record_WasInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_record_was = /** @type {((inputs: Workout_Live_Record_WasInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Record_WasInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_record_was(inputs)
	if (locale === "es-419") return es_419_workout_live_record_was(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_record_was(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_record_was(inputs)
	if (locale === "de-DE") return de_de2_workout_live_record_was(inputs)
	if (locale === "it-IT") return it_it2_workout_live_record_was(inputs)
	return en_us2_workout_live_record_was(inputs)
});
export { workout_live_record_was as "workout-live.record_was" }